import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.lucky_wheel.prize,
    props.lucky_wheel.prize_button,
    (prize, button) => {
        return {
            prize,
            button
        }
    }
)